"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the postive difference between two numbers
 */
function difference(a, b) {
    return Math.abs(a > b ? a - b : b - a);
}
exports.default = difference;
